<template lang="pug">
  include ../mixins
  +b.ru-lang-modal(v-if="visible" @click.self="dismiss")
    +e.dialog(
      ref="dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ru-lang-modal-title"
      tabindex="-1"
    )
      +e.BUTTON.close(
        type="button"
        :aria-label="_('Закрити')"
        @click.prevent="dismiss"
      ) ✕
      +e.SPAN.flag
      +e.P.title#ru-lang-modal-title {{ title }}
      +e.actions
        bem-button.de-text--size_2xs.--weight_bold(
          appearance="fill-accent-1"
          space="sm"
          rounded="sm"
          @event="goUkrainian"
        ) {{ btnSwitch }}
        bem-button.de-text--size_2xs(
          appearance="border-accent-1"
          space="sm"
          rounded="sm"
          @event="dismiss"
        ) {{ btnStay }}
</template>

<script>
import { languageHref } from '@helpers/url'

const STORAGE_KEY = 'dinternal_ru_language_notice_dismissed'

export default {
  name: 'ru-language-notice',
  data() {
    const texts = window.ruNotice || {}
    return {
      visible: false,
      title: texts.title || '',
      btnSwitch: texts.btnSwitch || '',
      btnStay: texts.btnStay || '',
    }
  },
  mounted() {
    // модалку показуємо лише на RU-версії й лише якщо користувач ще не закрив її
    if (window.language === 'ru' && this.title && !this.isDismissed()) {
      this.visible = true
      document.addEventListener('keydown', this.onKeydown)
      this.$nextTick(() => this.$refs.dialog && this.$refs.dialog.focus())
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    isDismissed() {
      try {
        return window.localStorage.getItem(STORAGE_KEY) === '1'
      } catch (e) {
        return false
      }
    },
    remember() {
      try {
        window.localStorage.setItem(STORAGE_KEY, '1')
      } catch (e) {
        // приватний режим / сховище недоступне — ховаємо лише на цю сесію
      }
    },
    onKeydown(event) {
      if ('Escape' === event.key || 'Esc' === event.key) this.dismiss()
    },
    dismiss() {
      this.remember()
      this.visible = false
      document.removeEventListener('keydown', this.onKeydown)
    },
    goUkrainian() {
      window.location.replace(languageHref('uk'))
    },
  },
}
</script>
